import React from "react";
import { Container, Spinner } from "react-bootstrap";

function WaitSpinner() {
  return (
    <Container className="content text-center pt-5">
      <Container className="p-5">Please wait ...</Container>
      <Spinner animation="border" variant="secondary" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </Container>
  );
}

export default WaitSpinner;
